import {Injectable} from '@angular/core';
import {urlJoin} from '../../../../../utils/urlJoin';
import {environment} from '../../../../../../environments/environment';
import {HttpClient, HttpParams, HttpRequest} from '@angular/common/http';
import {SearchObject} from '../../../../../domain/search/SearchObject';
import {Response, ServerResponse} from '../../../../../domain';
import {map} from 'rxjs/operators';
import {Shopprix} from '../../../../../domain/acheteur/shopprix';
import {
    Cahier
} from '../../../../../pages/content-layout/pages/acheteur/consulation/dialog-confirm-pub-consultation/add-cahier-consultation/add-cahier-consultation.component';

@Injectable({
    providedIn: 'root',
})
export class ConsultationFoService {
    constructor(private http: HttpClient) {
    }

    static get base() {
        return urlJoin(environment.server.hostSource, 'fournisseur');
    }

    static get baseGed() {
        return urlJoin(environment.server.hostSource, 'ged');
    }

    search(searchObject: SearchObject) {
        const resource = urlJoin(
            ConsultationFoService.base,
            'vSpShopMaster',
            'data'
        );
        return this.http.post(resource, searchObject);
    }

    save(data: Shopprix) {
        const resource = urlJoin(
            ConsultationFoService.base,
            'spShopAppDecPrc',
            'saveListSpShopAppDecPrc'
        );
        return this.http
            .post<Response<any>>(resource, data)
            .pipe(map((response) => response));
    }

    updateFlgGed(data) {
        const resource = urlJoin(
            ConsultationFoService.base,
            'spShopMaster',
            'flgGed' 
        );
        return this.http.put(resource,data);
    }

    savedevise(data: any) {
        const resource = urlJoin(
            ConsultationFoService.base,
            'spShopAppDecPrcFc',
            'saveListSpShopAppDecPrcFc'
        );
        return this.http
            .post<Response<any>>(resource, data)
            .pipe(map((response) => response));
    }

    checkdate(bidno: any) {
        const resource = urlJoin(
            ConsultationFoService.base,
            'consultation',
            'check',
            'date',
            'shopForDep',
            bidno
        );
        return this.http
            .get<Response<any>>(resource)
            .pipe(map((response) => response.payload));
    }

    checkparticaption(shopNo: any, shopModSeq: any) {
        const resource = urlJoin(
            ConsultationFoService.base,
            'vSpShopMaster',
            'offre'
        );
        return this.http
            .get<Response<any>>(resource, {
                params: new HttpParams()
                    .set('shopNo', shopNo)
                    .set('shopModSeq', shopModSeq),
            })
            .pipe(map((response) => response.payload));
    }

    addCahierFo(cahier: Cahier[]) {
        const resource = urlJoin(
            ConsultationFoService.baseGed,
            '/document',
            'saveFileShopAppDec'
        );
        let listDoc: string = '';
        const data: FormData = new FormData();

        //data.append("filedata", cahier.filedata);
        data.append('shopNo', cahier[0].shopNo);
        data.append('docCd', cahier[0].docCd);
        data.append('seqNo', cahier[0].seqNo);
        cahier.filter(res => {
            data.append('filedata', res.filedata);
            listDoc = listDoc + '{"docCd":' + res.docCd + ',"fileName":' + res.filedata.name + '},';
            // dataa.push(res.filedata)
        });
        listDoc = '[' + listDoc + ']';
        console.log('listDoc', listDoc);
        data.append('data', listDoc);
        const newRequest = new HttpRequest('POST', resource, data, {
            reportProgress: true,
            responseType: 'text',
        });
       // return this.http.request(newRequest).pipe(map((response) => response));
        return this.http
        .request(newRequest)
        .pipe(map((response) => response));
    }

    

    searchFourniPrix(searchObject: SearchObject) {
        const resource = urlJoin(
            ConsultationFoService.base,
            'vSpContMaster',
            'data'
        );
        return this.http.post(resource, searchObject);
    }

    saveShopProgress(f) {
        const resource = urlJoin(ConsultationFoService.base, 'spShopProgressTmp','insert');
        return this.http
            .post<ServerResponse>(resource, f)
            .pipe(map((response) => ({...response} as any)));
    }

    deleteProgress(shopNo, shopModSeq) {
        const resource = urlJoin(
            ConsultationFoService.base,
            'spShopProgressTmp',
            'deleteProg' + '?shopNo=' + shopNo + '&shopModSeq=' + shopModSeq
        );

        return this.http.delete(resource);
    }

    deleteSpShopAttach(shopNo, shopModSeq) {
        const resource = urlJoin(
            ConsultationFoService.base,
            'spShopProgressTmp',
            'deleteSpShopAttach' + '?shopNo=' + shopNo + '&shopModSeq=' + shopModSeq
        );

        return this.http.delete(resource);
    }

    countShopProgress(f) {
        const resource = urlJoin(ConsultationFoService.base, 'spShopProgressTmp','count');
        return this.http
            .post<ServerResponse>(resource, f)
            .pipe(map((response) => ({...response} as any)));
    }


    deleteAoProgress(shopNo, shopModSeq) {
        const resource = urlJoin(
            ConsultationFoService.base,
            'spShopProgressTmp',
            'deleteAoProg' + '?shopNo=' + shopNo + '&shopModSeq=' + shopModSeq
        );

        return this.http.delete(resource);
    }

    deleteAoAttach(shopNo, shopModSeq) {
        const resource = urlJoin(
            ConsultationFoService.base,
            'spShopProgressTmp',
            'deleteAoAttach' + '?shopNo=' + shopNo + '&shopModSeq=' + shopModSeq
        );

        return this.http.delete(resource);
    }
}
